module.exports = __webpack_public_path__ + "img/health-worries.4c7ecda9.svg";